import { Kosik } from "./Kosik.js";
import { PanelZbrane } from "./PanelZbrane.js";
//var ls = require('local-storage');
import ls from "local-storage";
import ConfigFromUrl from "./ConfigFromUrl.js";

var KonfiguraceZbrane = {
  enable: true,

  container: false, //--container

  url: "/konfigurace-zbrane/",
  odkazyJakoIframe: true,

  defaultUrl: "/ostatni-2/",

  configUrl: "/_setting/kf_zbrane-panely/",

  Config: false, //objekt configurace  z url

  Zbran: {
    Kord: {
      name: "Kord",
      url: "/kord/"
    },
    Fleret: {
      name: "Fleret",
      url: "/fleret/"
    },
    Savle: {
      name: "Šavle",
      url: "/savle/"
    }
  },
  Urceni: {
    _filterID: "pv24",

    Dospely: {
      name: "Dospělý",
      param: "615,618"
    },
    Dite: {
      name: "Dítě do 11ti let",
      param: "621"
    }
  },
  Provedeni: {
    _filterID: "pv38",

    Leve: {
      name: "Levé",
      param: "1199"
    },
    Prave: {
      name: "Pravé",
      param: "1196"
    }
  },
  /*
 Drzeni:{
   _filterID:'pv53',

   Francouzske:{
        name:'Francouzské',
        param:'1397',

   },
   Pistolove:{
       name:'Pistolové',
       param:'1454',
   }
 },
 */

  Drzeni: {
    _filterID: "pv77", //--PRO DRŽENÍ

    Francouzske: {
      name: "Francouzské",
      param: "1475" //-francouzska-rucka
    },
    Pistolove: {
      name: "Pistolové",
      param: "1478"
    }
  },
  Rucka: {
    _filterID: "pv56",
    name: "Vyber ručku z katalogu",
    //_param: "1460,1355,1536",
    //server
    _param: "1460,1355,1556",
    title: "Ručka"
  },
  Cepel: {
    _filterID: "pv56",
    _param: "1376", //1370,1373,
    name: "Vyber čepel z katalogu",
    title: "Čepel"
  },
  Ciska: {
    _filterID: "pv56",
    _param: "1379",
    name: "Vyber číšku z katalogu",
    title: "Číška"
  },
  PodlozkaCisky: {
    _filterID: "pv56",
    _param: "1385,1469",
    name: "Vyber podložku číšky z katalogu",
    title: "Podložka"
  },
  Mustek: {
    _filterID: "pv56",
    _param: "1382",
    name: "Vyber můstek z katalogu",
    title: "Můstek"
  },
  Matka: {
    _filterID: "pv56",
    //_param: "1358,1361,1542",
    //server
    _param: "1358,1361,1562",
    name: "Vyber matku z katalogu",
    title: "Matka"
  },
  Sestaveni: {
    _filterID: "pv56",
    //_param: "1545",
    //server
    _param: "1568",
    name: "Vyber sestavení zbraně",
    title: "Sestavení zbraně"
  },

  vybrano: {
    Zbran: false,
    Urceni: false,
    Provedeni: false,
    Drzeni: false
  },
  urlAdresy: {
    Rucka: false,
    Cepel: false,
    Ciska: false,
    PodlozkaCisky: false,
    Mustek: false,
    Matka: false,
    Sestaveni: false
  },

  smazVse: function() {
    ls.remove("ladzo.cz/KF/Vyber");
    ls.remove("ladzo.cz/KF/Urls");
  },

  vybraneVolby: function() {
    if (this.vybrano.Drzeni === false) return false;
    return true;
  },
  /*
   ověří zda je je např ručka v košiku

   vybraneVolbyVKosiku('Rucka') - zjisti jen pro rucku
   vybraneVolbyVKosiku() - zjisti jen pro vsechny rucku, cepel a pod

 */
  vybraneVolbyVKOsiku($druhZbozi = false) {
    Lc.f("KF:vybraneVolbyVKOsiku");

    if (!this.vybraneVolby()) return false;

    if (_.isEmpty(Kosik.polozky)) return false;

    var $stav = false;
    var $arrDruhyZbozi = [];

    _.forEach(Kosik.polozky, function($Val) {
      if ($druhZbozi && $Val.druhZbozi == $druhZbozi) {
        $stav = true;
        return true;
      }
      $arrDruhyZbozi.push($Val.druhZbozi);
    });

    let $arrDiff = _.difference(_.keys(this.urlAdresy), $arrDruhyZbozi);
    if (!$arrDiff.length) $stav = true;

    return $stav;
  },

  nactiConfig() {
    try {
      let $C = ls.get("ladzo.cz/Config");
      if (!$C) throw new Error("Nenalezena konfigurace");

      if ($C.verze !== Top.razitko) throw new Error("Neshoduji se razitka");

      this.Config = $C;
      Lc.log("ulozenyConfig1", this.Config);
      $("#dvKf .dvP").trigger("ladzo:panelAktualizujNapovedy");
      $("#dvKf .dvKfMsgfinal").trigger("ladzo:panelAktualizujFinalniHlasku");
      Lc.log($("#dvKf .dvP").length);
    } catch (err) {
      let $Config = new ConfigFromUrl(this.configUrl);
      Lc.err("nactiConfig err", err);
      var $callback = function($Obj) {
        Lc.h("resul $Obj");
        Lc.log("$Obj", $Obj);
        $Obj.verze = Top.razitko;

        KonfiguraceZbrane.Config = $Obj;

        KonfiguraceZbrane.ulozConfig();
        $("#dvKf .dvKfMsgfinal").trigger("ladzo:panelAktualizujFinalniHlasku");
        $("#dvKf .dvP").trigger("ladzo:panelAktualizujNapovedy");
      };
      $Config.getDataFromTable($callback, { id: "tbHelp" });
      Lc.log("neuulozenyConfig", KonfiguraceZbrane);
    }
  },

  ulozConfig: function() {
    ls.set("ladzo.cz/Config", this.Config);
  },

  /**
   *  nacte konfiguraci z tabulky
   **/
  loadConfigFromUrl: function() {
    //if(this.Config)
    this.nactiConfig();

    //let $Config = new ConfigFromUrl(this.configUrl);
  },

  ulozVyber: function($typ, $hodnota) {
    this.vybrano[$typ] = $hodnota;
    ls.set("ladzo.cz/KF/Vyber", this.vybrano);
  },
  nactiVyber: function() {
    let $pom = ls.get("ladzo.cz/KF/Vyber");
    if ($pom) {
      this.vybrano = $pom;
    }
    return this.vybrano;
  },

  ulozUrlAdresu: function($typ, $hodnota) {
    this.urlAdresy[$typ] = $hodnota;
    ls.set("ladzo.cz/KF/Urls", this.urlAdresy);
  },
  nactiUrlAdresy: function() {
    let $pom = ls.get("ladzo.cz/KF/Urls");
    if ($pom) {
      this.urlAdresy = $pom;
    }
    return this.urlAdresy;
  },

  vypisVolby: function() {
    var $div = this.container;

    var $kodPanelu = PanelZbrane.vypisPanely();
    $div.append($kodPanelu);

    let $vybrano = this.nactiVyber();

    PanelZbrane.nastavUdalosti($div);
    PanelZbrane.nastavVychoziHodnoty($div, $vybrano);

    $(document).trigger("ladzo:aktualizacePaneluZbrane");

    if (this.odkazyJakoIframe) PanelZbrane.odkazyDoPopupOkna($div);
  }, //vypisVolby
  _init: function() {
    //let $stav=  KofingiguraceZbrane.Uzivatel.overeniPrihlaseni();
    //KofingiguraceZbrane.Uzivatel.prihlasen=$stav;
    this.nactiVyber();
    this.nactiUrlAdresy();
  },

  createDiv: function($id) {
    this.container = $('<div id="' + $id + '"></div>');
    return this.container;
  }
};

KonfiguraceZbrane._init();

export { KonfiguraceZbrane };
